"use client";

import { Button } from "@ui/components/core/Button";
import { useTranslations } from "next-intl";
import { HeroAgentCardLayout } from "./Components";

export interface AgentCallAckViewProps {
  onAgree: () => void;
  onCancel: () => void;
}

export function AgentCallAckView({ onAgree, onCancel }: AgentCallAckViewProps) {
  const t = useTranslations("ClientKeys.hero_agent");

  return (
    <HeroAgentCardLayout width='lg' className='tw-h-full tw-flex-col tw-flex tw-items-center tw-justify-center'>
      <div className='tw-w-full'>
        <h3 className='tw-mb-5 tw-text-center tw-type-2xl'>{t("call_agent_title")}</h3>

        <p className='tw-text-center tw-text-gray-500 tw-mb-10 tw-type-2xs sm:tw-type-xs'>
          {t.rich("call_agent_consent_text", {
            termsLink: chunks => (
              <a
                href='/terms-of-use'
                target='_blank'
                className='tw-text-default tw-underline tw-underline-offset-2 hover:tw-no-underline'
              >
                {chunks}
              </a>
            ),
            privacyLink: chunks => (
              <a
                href='/privacy-policy'
                target='_blank'
                className='tw-text-default tw-underline tw-underline-offset-2 hover:tw-no-underline'
              >
                {chunks}
              </a>
            ),
          })}
        </p>

        <div className='tw-flex tw-justify-center tw-gap-3'>
          <Button variant='primary' size='lg' onClick={onAgree}>
            {t("agree")}
          </Button>
          <Button variant='elevated' size='lg' onClick={onCancel}>
            {t("cancel")}
          </Button>
        </div>
      </div>
    </HeroAgentCardLayout>
  );
}
